import { gql } from '@apollo/client';

export default gql`
  mutation updateProducer($id: Int!, $producerPatch: ProducerPatch!) {
    updateProducerById(input: { id: $id, producerPatch: $producerPatch }) {
      producer {
        id
      }
    }
  }
`;
